import { render, staticRenderFns } from "./ArticleContent.vue?vue&type=template&id=385391c6&"
import script from "./ArticleContent.vue?vue&type=script&lang=ts&"
export * from "./ArticleContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports